export default {
    name: 'ContextUser',
    properties: {
        user_id: { name: 'id' },
        uuid: { required: true },
        groups: { type: 'array', name: 'groups' },
        custom: {},
    },
};
